import styled from "styled-components";
import Container from "react-bootstrap/Container";
import { siteGray } from "../../providers/Theme";

export const StyledContainer = styled(Container)`
  background-color: ${siteGray};
  color: black;
`;
